module.exports = __webpack_public_path__ + "fonts/GT-Black.e4f44de9.otf";